import React, { useEffect, useCallback, useState} from 'react';
import {PIANO_ROLL} from 'constants/arrangement-modes.js';
import MacroOverlay from '../MacroOverlay.js';
import {connect} from 'react-redux';
import {
    setTrackAutomationParameter,
    setArrangementBottomMode,
    setShowPianoRoll,
    setShowAutomation,
       } from 'actions/index.js';

const EnvParam = ({
    parameter,
    value,
    fullText,
    automations,
    setShowAutomation,
    setShowPianoRoll,
    setBottomMode,
    setTrackAutomationParameter,
    setParameter,
    selectedParameter
}) => {
    let [editing, setEditing] = useState(false);

    let name = parameter.name === "Attack" ?
        (fullText ? "Atk" : "A") :
        parameter.name === "Decay" ?
        (fullText ? "Dec" : "D") :
        parameter.name === "Sustain" ?
        (fullText ? "Sus" : "S") : 
        parameter.name === "Level" ?
        "L" :
        (fullText ? "Rel" : "R");

    const showAutomations = () => {
        setShowAutomation(true);
        setShowPianoRoll(true);
        setBottomMode(PIANO_ROLL);
        if (parameter.track) {
            let track = parameter.track.instrumentRack ?
                parameter.track.instrumentRack : parameter.track;
            setTrackAutomationParameter(track.id, parameter);
        }
    };
        
    let className = "env-param";
    if (parameter.name === "Sustain") {
        className += " sustain";
    }

    if (parameter === selectedParameter) {
        className += " selected";
    }
    return (
        <div
          onClick={() => setParameter(parameter === selectedParameter ? undefined : parameter)}
          className={className}>
          <MacroOverlay parameter={parameter}/>
          {name}: <span className="param-val">{parameter.name === "Sustain" || name === "L" ? Math.round(value*10) / 10.0 : Math.round(value)}</span>
          {automations ? <img
                           onClick={showAutomations}
                           className="automation-icon" src="/automation-icon-disabled.png"/> : ''}
        </div>
    );
}


const mapStateToProps = (state, props) => {
  return {
      value: props.parameter.get(),
      automations: props.parameter.automations && props.parameter.automations.length > 0
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
        setShowPianoRoll: p => dispatch(setShowPianoRoll(p)),
        setShowAutomation: p => dispatch(setShowAutomation(p)),
        setTrackAutomationParameter: (id, parameter) =>
            dispatch(setTrackAutomationParameter(id, parameter)),
        setBottomMode: (bottomMode) =>
            dispatch(setArrangementBottomMode(bottomMode))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EnvParam);
